import { collection, doc, getDoc, getDocs, query, orderBy, limit } from 'firebase/firestore';
import { db } from '../firebase';
import type { TenantSharedFields, TenantModules } from '@shared/types';

export interface TenantConsoleListItem extends TenantSharedFields {
  modules?: TenantModules;
  email_domain?: string;
}

export async function listTenants(opts: { max?: number } = {}): Promise<TenantConsoleListItem[]> {
  const q = query(
    collection(db, 'tenants'),
    orderBy('nome_azienda'),
    limit(opts.max ?? 200),
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...(d.data() as Omit<TenantConsoleListItem, 'id'>) }));
}

export async function getTenantById(id: string): Promise<TenantConsoleListItem | null> {
  const ref = doc(db, 'tenants', id);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return { id: snap.id, ...(snap.data() as Omit<TenantConsoleListItem, 'id'>) };
}
